<template>
  <div id="dashboard" class="content">
    <div class="block block-rounded block-bordered">
      <ul class="nav nav-tabs nav-tabs-block" data-toggle="tabs" role="tablist">
        <li class="nav-item" v-for="(item,index) in bis" :key="index">
          <a
            class="nav-link"
            :class="['btabs-animated-fade-'+item.BIS_TYPE ,
            [bis.length>1&&(item.BIS_TYPE==type||index==0)?'active':''],
            [bis.length==1?' oneTable':'']]"
            href="javascript:void(0)"
            @click="showTab('btabs-animated-fade-'+item.BIS_TYPE,item.BIS_TYPE)"
          >{{item.BIS_NAME}}</a>
        </li>
        <li class="nav-item ml-auto"></li>
        <!-- <div class="block-header block-header-default" style="padding-left: 0;">
          <button
            type="button"
            class="btn-block-option"
            data-toggle="block-option"
            data-action="fullscreen_toggle"
          >
            <i class="si si-size-fullscreen"></i>
          </button>
        </div> -->
      </ul>
      <div class="block-content tab-content overflow-hidden">
        <div class="tab-pane fade show active" id="btabs-animated-fade-1" role="tabpanel">
          <cell ref="cell"></cell>
        </div>
        <div class="tab-pane fade" id="btabs-animated-fade-2" role="tabpanel">
          <carport ref="carport"></carport>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Util from "../../../Util.js";
import pageSize from "../../../components/pageSize";
import cell from "./cell";
import carport from "./carport";

export default {
  name: "index",
  data() {
    return {
      userPackages: [],
      setToday: new Date(),
      starttime: "",
      endtime: "",
      key: "",
      page: 1,
      size: 10,
      total: 1,
      pageSize: 20,
      selects: [10, 20, 30, 50],
      state: "",
      clipboard: null,
      sorting: "",
      orderBy: false,
      type: 1,
      bis: [
        {
          BIS_NAME: "站点信息",
          BIS_TYPE: 1,
          SHOW_TAB: true
        },
        {
          BIS_NAME: "车棚信息",
          BIS_TYPE: 2,
          SHOW_TAB: false
        }
      ]
    };
  },
  components: {
    pageSize,
    cell,
    carport
  },
  computed: {
    duration() {
      return this.$store.state.duration;
    },
    roleName() {
      return this.$store.state.roleName;
    },
    totalPage() {
      if (this.total == 0) {
        return 0;
      } else {
        return Math.ceil(this.total / this.pageSize, 1);
      }
    },
    pagerCount() {
      return this.$store.state.pagerCount;
    },
    isMobile() {
      return this.$store.state.isMobile;
    },
    regionParams() {
      return this.$store.state.regionParams;
    },
    entry() {
      return this.$store.state.entry;
    }
  },
  watch: {
    "$store.state.duration": {
      handler: function(val, oldVal) {
        if (typeof oldVal === "undefined") return;
        if (JSON.stringify(val) != JSON.stringify(oldVal)) {
        }
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {},
  methods: {
    changePage(val) {
      this.page = val;
    },
    showTab(el, type) {
      this.type = type;
      $(`.${el}`).tab("show");
      for (let i of $(`.tab-pane`)) {
        i.className = "tab-pane fade";
      }
      $(`#${el}`).tab("show");
      if (type == 1) {
        this.$refs.cell.getCell(this.$route.params.id);
      } else {
        this.$refs.carport.getCarport(this.$route.params.id);
      }
    }
  }
};
</script>